module.exports = __webpack_public_path__ + "static/media/opex.957d925d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/opex.svg
// module id = 856
// module chunks = 7